import { EventEmitter } from '@angular/core';
import {Component, Input, OnInit, Output} from '@angular/core';
import {Subject} from 'rxjs';

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent implements OnInit {

  @Input() title: string;
  @Input() e2ePrefix = 'accordion';
  @Output() loadData = new EventEmitter();
  @Input() closeAccordionPrompt: Subject<boolean> = null;

  isActive: boolean;

  constructor() { }

  ngOnInit(): void {
    if (this.closeAccordionPrompt) {
      this.closeAccordionPrompt.subscribe(status => {
        if (status) {
          this.closeAccordion();
        }
      });
    }
  }

  /**
   * Toggles isActive variable
   */
  toggleAccordion(): void {
    this.isActive = !this.isActive;
    this.loadData.emit(this.isActive);
  }

  closeAccordion(): void {
    this.isActive = false;
    this.loadData.emit(this.isActive);
  }

  /**
   * Generates e2e id with prefix
   * @param name: string
   */
  generateE2EName(name: string): string {
    return `${this.e2ePrefix}-${name}`;
  }

}
